import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as navActions from "../actions/navigation";
import { navigationItems } from "../selectors/navigation";

import Rune from "./Rune";
import RunePlacehodler from "./RunePlaceholder";

class Navigation extends Component {
  constructor(props){
    super(props)
    this.menuRef = React.createRef();
  }
  closeNavListener = e => {
    if (!this.props.isMenuOpen) {
      this.unbindCloseNavListener();
      return;
    }
    if (e.target.closest("ul.main-menu") === null){
      this.handleToggleMenu();
    }
  }
  bindCloseNavListener = () => {
    document.addEventListener("click", this.closeNavListener)
    document.addEventListener("touchstart", this.closeNavListener)
  }
  unbindCloseNavListener = () => {
    document.removeEventListener("click", this.closeNavListener)
    document.removeEventListener("touchstart", this.closeNavListener)
  }
  handleToggleMenu = () => {
    if (this.props.isMenuOpen){
      this.unbindCloseNavListener()
    } else {
      this.bindCloseNavListener()
    }
    this.props.onToggleMenu();
  }
  render() {
    return (
      <nav
        style={{
          opacity: this.props.shouldShow ? 1 : 0,
          backgroundColor: `rgba(50,50,50,${this.props.backgroundOpacity})`
        }}
      >
        <div className="menu-icon" onClick={this.handleToggleMenu}>&#9776;</div>
        <h1>Ben Bright</h1>
        <ul className="main-menu" ref={this.menuRef}>
          {this.props.items.map(item => {
            const linkBody = item.isUnlocked ? (
              <Fragment>
                <Rune scale={0.5} shouldHideDots={true} name={item.rune} />{" "}
                <span>{item.title}</span>
              </Fragment>
            ) : (
              <RunePlacehodler name={item.title} />
            );

            return (
              <li key={item.title}>
                <Link to={item.path}>{linkBody}</Link>
              </li>
            );
          })}
        </ul>
      </nav>
    );
  }
}

function mapStateToProps(state) {
  return {
    items: navigationItems(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(navActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Navigation));



// WEBPACK FOOTER //
// ./src/components/Navigation.js